export default "__VITE_ASSET__Lte4bweQ__"